<update-pendency-assignee-modal-body
  (hideDialogEvent)="hideDialog()"
  (showDialogEvent)="showDialog()"
  (closeDialogEvent)="closeDialogEvent($event)"
  [pendencyId]="pendencyId"
  [assignee]="assignee"
></update-pendency-assignee-modal-body>
